import { useMemo } from 'react'
import { useApiQuery } from '../../../lib/api'
import type { ChatwootDirectoryResponse } from '../types'

// Loads the agents/teams that can actually be @-mentioned in a given
// conversation. Chatwoot only notifies administrators and members of the
// conversation's inbox, so the picker must be scoped per conversation rather
// than reusing the account-wide directory. Empty until a conversation is open.
const EMPTY_DIRECTORY: ChatwootDirectoryResponse = { agents: [], teams: [] }

export function useChatwootMentionTargets(
  conversationId?: string | null,
  companyUid?: string | null
) {
  const requestData = useMemo(
    () => ({
      conversationId: conversationId?.trim() || '',
      companyUid: companyUid?.trim() || undefined,
    }),
    [conversationId, companyUid]
  )

  return useApiQuery<
    { conversationId?: string; companyUid?: string },
    ChatwootDirectoryResponse
  >('chatwoot/get_inbox_members', {
    data: requestData,
    startWithValue: EMPTY_DIRECTORY,
  })
}
